var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLinki = function SvgLinki(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z",
    "data-name": "Rectangle 1596"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "m6.49 19.18-1.67-1.67a2.8 2.8 0 0 1 0-3.96l4.06-4.06a2.8 2.8 0 0 1 3.96 0l1.38 1.37a.8.8 0 0 1 0 1.13.8.8 0 0 1-1.14 0l-1.37-1.37a1.2 1.2 0 0 0-1.7 0l-4.06 4.06a1.2 1.2 0 0 0 0 1.7l1.67 1.67a1.2 1.2 0 0 0 1.7 0l2-2a.8.8 0 0 1 1.13 0 .8.8 0 0 1 0 1.14l-2 2a2.78 2.78 0 0 1-1.98.81 2.8 2.8 0 0 1-1.98-.82m4.67-4.66-1.38-1.37a.8.8 0 0 1 0-1.14.8.8 0 0 1 1.14 0l1.37 1.38a1.2 1.2 0 0 0 1.7 0l4.06-4.07a1.2 1.2 0 0 0 0-1.7l-1.67-1.67a1.2 1.2 0 0 0-1.7 0l-2 2a.8.8 0 0 1-1.12 0 .8.8 0 0 1 0-1.13l1.99-2a2.8 2.8 0 0 1 3.96 0l1.67 1.67a2.8 2.8 0 0 1 0 3.96l-4.06 4.07a2.8 2.8 0 0 1-1.98.81 2.8 2.8 0 0 1-1.98-.81",
    "data-name": "Union 34"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLinki);
export default ForwardRef;